/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".status-dot[_ngcontent-%COMP%]{display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px}.status-dot.status-0[_ngcontent-%COMP%]{background-color:var(--success-color)}.status-dot.status-1[_ngcontent-%COMP%]{background-color:var(--problem-color)}.status-dot.status-2[_ngcontent-%COMP%]{background-color:var(--fail-color)}.status-label.status-0[_ngcontent-%COMP%]{color:var(--success-color)}.status-label.status-1[_ngcontent-%COMP%]{color:var(--problem-color)}.status-label.status-2[_ngcontent-%COMP%]{color:var(--fail-color)}.spinner-label[_ngcontent-%COMP%]{margin-left:.4rem}"];
export { styles as styles };

